<template>
  <fts-design-modal
    width="1200px"
    append-container-class="workflow-container"
    class="fts-workflow-diagram"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <template #title>
      <fts-label-group
        :item="module"
        emoji
        :emoji-size="25"
        icon-class="design-modal-header-emoji"
        label-class="design-modal-header-name"
        class="design-modal-header-std__title"
        v-if="moduleId"
      />
      <div class="design-modal-header-title" v-else>Workflow</div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Workflow</span>
      <span class="design-modal-header-description">
        diagram showing the flow of state to another state through activity
      </span>
    </template>
    <!-- body -->
    <template #body>
      <!-- diagram -->
      <div id="cy" class="workflow-diagram"></div>
    </template>
  </fts-design-modal>
</template>

<script>
import cytoscape from "cytoscape";
import flowDiagram from "../library/flowDiagram";
import dagre from "cytoscape-dagre";

cytoscape.use(dagre);

let dagreLayout = {
  name: "dagre",
  ranker: "network-simplex",
  nodeSep: 100,
  rankSep: 100,
  rankDir: "TB",
  edgeSep: 200,
};

import { clientStore } from "../store/clientStore";

import FTSDesignModal from "../design/FTSDesignModal";
import FTSLabelGroup from "./display/FTSLabelGroup";
import FTSBtn from "./FTSBtn";
import FTSMoji from "./FTSMoji";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-label-group": FTSLabelGroup,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji,
  },
  methods: {
    async show() {
      this.$refs.ftsDesignModal.show();
      let response = await clientStore.dispatch("loadDiagram", this.module.id);
      let data = response.data;

      // set diagram
      this.$nextTick(() => {
        let vm = this;
        var hasDiagram = data.diagram;
        var cy = cytoscape({
          container: document.getElementById("cy"),
          wheelSensitivity: 0.1,
          // edgeEditing: options,
          // layout: { name: "preset" }, //dagreLayout,
          layout: hasDiagram != null ? { name: "preset" } : dagreLayout,
          style: flowDiagram.style,
          elements: {
            nodes: flowDiagram.getNodes(
              data.states,
              data.flows,
              [],
              data.diagram
            ),
            edges: flowDiagram.getEdges(
              data.activities,
              data.states,
              data.flows,
              [],
              data.diagram
            ),
          },
          ready: function () {
            vm.cy = this;
          },
        });
      });
    },
    close() {
      this.$refs.ftsDesignModal.close();
    },
  },
  computed: {
    module() {
      return clientStore.state.module;
    },
    moduleId() {
      return clientStore.getters.moduleId;
    },
  },
};
</script>

<style lang="scss">
.fts-workflow-diagram {
  .workflow-container {
    height: 100%;
  }
  .workflow-diagram {
    width: 100%;
    height: 100%;
  }
}
</style>